
export default {

	'ball': 'Поиграйте с ней в мяч: это вызывает радость от прогулки у любой собаки!',
	'rope': 'Возьмите на прогулку канатик и поиграйте с собакой в веселые перетягивания.',

	'catch-up': 'Устройте веселые догонялки с вашим питомцем — он за вами или вы за ним.',

	'toy-squeaky': 'Дайте ей пищащую игрушку, которая увлечет собаку на время прогулки.',
	'toy-food': 'Пусть питомец побегает за игрушками с кормом внутри — позанимается и получит награду.',
	'toy-heavy': 'Попробуйте поиграть с плотными игрушками, которые так весело трепать на прогулке!',
	'toy-soft': 'С питомцем поиграйте при помощи мягких игрушек — их можно трепать или бегать за ними.',
	'toy-soft-puppy': 'С щенком поиграйте при помощи мягких игрушек — их можно трепать или бегать за ними.',
	'toy-soft-small': 'С миниатюрным питомцем поиграйте при помощи мягких игрушек — их можно трепать или бегать за ними.',

	'training-basic': 'Попробуйте обучить питомца основным командам — «ко мне», «сидеть», «фу» и многим другим.',
	'training-trick': 'Попробуйте обучить питомца основам трюковой дрессировки — командам «усни», «кувырок», «дай лапу» и многим другим.',
	'training-jump': 'Займитесь дрессировкой сложного прыжка от предмета.',
	'training-jump-over': 'Помогите питомцу освоить полезный навык прыжков через препятствия.',
	'training-game': 'Займитесь на прогулке дрессировкой в игровой увлекательной форме.',
	'training-aport': 'Обучите питомца команде «апорт»: навык приносить вещь обратно хозяину развивает дисциплину.',
	'training-pick': 'Обучите собаку важному навыку не подбирать с земли вредные предметы или еду.',
	'training-discipline': 'Займитесь дрессировкой на выдержку: так питомец станет более дисциплинированным.',
	'training-stranger': 'Обучите собаку не брать еду у незнакомцев — это очень важный навык!',

	'search-food': 'Поиграйте с ней в увлекательную игру на поиск лакомств: это развивает чутье у собак.',
	'search-toy': 'Обучите питомца игре на поиск знакомых вещей — например, мяча или игрушки.',
	'search-owner': 'Если вы на прогулке вдвоем с кем-то из близких, то поиграйте в «поиск хозяина».',

	'run-widely': 'Вдоволь побегайте вместе со своей собакой.',
	'run-usual': 'Просто побегайте с собакой на прогулке: это всегда очень весело!',
	'run-short': 'Совершите несколько непродолжительных пробежек с собакой.',

	'walk-quiet': 'Прогуляйтесь с собакой в спокойном и размеренном темпе.',
	'walk-active': 'Прогуляйтесь с собакой в активном темпе.',

	'frisbee': 'Пусть ваша собака побегает за фрисби: это поможет развитию мускулатуры питомца.',
	'mixed': 'Совместите на прогулке сразу несколько активностей: мяч, догонялки, обучение командам.',

	'velo': 'Возьмите на прогулку велосипед и покатайтесь на нем, чтобы питомец бежал рядом.',

}



// WEBPACK FOOTER //
// ./src/data/games.js